import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { apiService } from "../services/api";
import {
  Section,
  Container,
  Heading,
  Card,
  CardInner,
  Button,
} from "toddlar-ui";

interface SimpleOrder {
  _id: string;
  totalPoints: number;
  status: string;
  orderDate: string;
}

const Status: React.FC = () => {
  const navigate = useNavigate();
  const [orders, setOrders] = useState<SimpleOrder[]>([]);
  const [userPoints, setUserPoints] = useState<number>(0);

  useEffect(() => {
    const run = async () => {
      try {
        const profile = await apiService.getProfile();
        if (profile.success && profile.data) {
          setUserPoints(profile.data.user.points);
        }
        const res = await apiService.getUserOrders({ limit: 5 });
        if (res.success && res.data) {
          setOrders(
            res.data.orders.map((o: any) => ({
              _id: o._id,
              totalPoints: o.totalPoints,
              status: o.status,
              orderDate: o.orderDate,
            }))
          );
        }
      } catch {}
    };
    run();
  }, []);

  return (
    <div className="min-h-screen bg-sand-50">
      <Section background="sand">
        <Container>
          <Heading size="display" className="text-ink md:leading-[1.05]">
            Your Overview
          </Heading>
          <Heading as="p" size="lead" className="mt-4">
            Points: {userPoints}
          </Heading>
          <div className="mt-8 flex gap-4">
            <Button onClick={() => navigate("/browse")} size="large">
              Browse toys
            </Button>
          </div>
        </Container>
      </Section>

      <Section>
        <Container>
          <Heading size="h2" className="mb-6">
            Recent Orders
          </Heading>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {orders.length === 0 ? (
              <Card>
                <CardInner>
                  <p className="text-ink-muted">No orders yet.</p>
                </CardInner>
              </Card>
            ) : (
              orders.map((o) => (
                <Card key={o._id}>
                  <CardInner>
                    <div className="flex justify-between items-center">
                      <div>
                        <div className="text-ink font-semibold">{o.status}</div>
                        <div className="text-ink-muted text-sm">
                          {new Date(o.orderDate).toLocaleString()}
                        </div>
                      </div>
                      <div className="text-ink">{o.totalPoints} pts</div>
                    </div>
                  </CardInner>
                </Card>
              ))
            )}
          </div>
        </Container>
      </Section>
    </div>
  );
};

export default Status;
